export default {
  SET_INDUSTRY_FIELDS(state, value) {
    state.stock.industryFields = value
  },
}
